import { Box, Typography as MuiTypography } from "@mui/material";

import { theme } from "../../mui-customs/Theme";

interface ProfileTagProps {
  text: string;
}

const ProfileTag = ({ text }: ProfileTagProps) => {
  return (
    <Box
      sx={{ p: "4px 8px", background: theme.whiteBg.WBG3, borderRadius: "6px" }}
    >
      <MuiTypography
        sx={{
          fontSize: "12px",
          lineHeight: "16px",
          fontWeight: "400",
          fontFamily: "Poppins",
          color: theme.grey2[300],
        }}
      >
        {text}
      </MuiTypography>
    </Box>
  );
};

export default ProfileTag;
